module.exports = __webpack_public_path__ + "static/media/info.1b1a0d45.svg";